<ng-container *transloco="let t; read: 'ime.manufacturing.resources'">
  <button type="button" class="btn btn-outline-primary me-1" (click)="showCopyModal(copyAskCodeAndName)">
    <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#arrows-right-left'">
    </svg>
    Copy
  </button>
  <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="showGraph()">
    <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#fork'">
    </svg>
    {{t('Graph')}}
  </button>
</ng-container>

<ng-template #copyAskCodeAndName>
  <div class="modal-header" ngxModalDraggable>
    <h4 class="modal-title pull-left">Copy {{resource.Code}}: {{resource.Name}}</h4>
    <button type="button" class="btn-close pull-right" aria-label="Close" (click)="askCopyCodeNameModal.dismiss()">

    </button>
  </div>
  <div class="modal-body">
    <div class="form-group row">
      <label for="newCode" class="col-sm-2 col-form-label">New Code</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="newCode" name="newCode" [(ngModel)]="copyNewCode">
      </div>
    </div>
    <div class="form-group row">
      <label for="newName" class="col-sm-2 col-form-label">New Name</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="newName" name="newName" [(ngModel)]="copyNewName">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="copy()">Copy</button>
  </div>
</ng-template>
